module.exports = __webpack_public_path__ + "static/media/kitapaktivasyonu_ADIM1.b5664fda.jpg";